import React from "react";

import { Dropdown } from "@components/General/Dropdown/dropdown.component";
import { DropdownItem } from "@components/General/Dropdown/dropdownItem.component";

import { ProductVariant } from "lib/@types/service/product/shared";

import "./dropdownFallback.scss";

type Props = {
    variantGroup: ProductVariant[];
    sku: string;
};

const DropDown = ({ variantGroup, sku }: Props) => {
    const activeOption = variantGroup.filter(variant => variant.sku === sku)[0]
        .productTitle;

    return (
        <Dropdown
            className={"w-100 mb-3"}
            placeholder={activeOption}
            components={{
                toggle: {
                    color: "none",
                    className: "dropdown-fallback__dropdown w-100 d-flex",
                },
                menu: {
                    className: "w-100",
                },
            }}
        >
            {variantGroup.map(variant => (
                <DropdownItem
                    key={variant.productTitle}
                    tag="a"
                    href={variant.url}
                    label={variant.productTitle}
                />
            ))}
        </Dropdown>
    );
};

export default DropDown;
